import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles, Check } from "lucide-react";
import { usePlanAccess } from "../hooks/usePlanAccess";
import { openUpgrade } from "./UpgradeDialog";

const LOCK_COPY = {
  discover: {
    title: "Discover is on the Starter plan",
    body: "Find decision-makers by industry and location, enrich their emails and phones, and push them straight into your CRM.",
    perks: ["Discover + Advanced Search", "My Leads, New Businesses & Scan History", "100 verified leads every month"],
  },
  lead_tools: {
    title: "This is a Starter plan feature",
    body: "Upgrade to unlock the full lead toolkit and start filling your pipeline automatically.",
    perks: ["Discover + Advanced Search", "My Leads, New Businesses & Scan History", "100 verified leads every month"],
  },
};

export const LockedFeature = ({ feature = "lead_tools", trialUsed }) => {
  const navigate = useNavigate();
  const copy = LOCK_COPY[feature] || LOCK_COPY.lead_tools;
  useEffect(() => {
    if (trialUsed) openUpgrade("discover_out");
  }, [trialUsed]);
  return (
    <div className="content-card" data-testid={`locked-${feature}`} style={{ maxWidth: 640, margin: "40px auto", textAlign: "center", padding: "48px 28px" }}>
      <div style={{ width: 64, height: 64, borderRadius: 18, background: "#eff6ff", display: "grid", placeItems: "center", margin: "0 auto 18px" }}>
        <Lock size={28} color="#2563eb" />
      </div>
      <h2 style={{ fontSize: 24, fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>{copy.title}</h2>
      {trialUsed && <p style={{ color: "#b45309", fontWeight: 600, fontSize: 14, marginBottom: 6 }} data-testid="discover-trial-ended">You've used your 2 free Discover scans.</p>}
      <p style={{ color: "#475569", marginBottom: 20 }}>{copy.body}</p>
      <ul style={{ listStyle: "none", padding: 0, margin: "0 auto 24px", display: "inline-grid", gap: 8, textAlign: "left" }}>
        {copy.perks.map((p) => (
          <li key={p} style={{ display: "flex", gap: 8, alignItems: "center", color: "#334155", fontSize: 14 }}><Check size={16} color="#16a34a" /> {p}</li>
        ))}
      </ul>
      <div>
        <Button onClick={() => navigate("/plans")} data-testid={`locked-${feature}-upgrade-btn`} style={{ padding: "12px 22px", height: "auto" }}>
          <Sparkles size={16} style={{ marginRight: 8 }} /> See plans & upgrade
        </Button>
      </div>
    </div>
  );
};

export const PlanGate = ({ feature, lockAs, children }) => {
  const sub = usePlanAccess();
  if (!sub?.features) return children;
  if (sub.features[feature]) {
    const trial = sub.discover_trial;
    if (feature === "discover" && trial?.active) {
      return (
        <>
          <div data-testid="discover-trial-banner" style={{ background: "#fffbeb", border: "1px solid #fde68a", color: "#92400e", borderRadius: 12, padding: "12px 16px", marginBottom: 16, fontSize: 14, fontWeight: 600 }}>
            Free trial: {trial.remaining} of {trial.limit} Discover scans left. Upgrade to Starter for full access.
          </div>
          {children}
        </>
      );
    }
    return children;
  }
  const trialUsed = feature === "discover" && sub.plan === "free" && sub.discover_trial?.used >= sub.discover_trial?.limit;
  return <LockedFeature feature={lockAs || feature} trialUsed={trialUsed} />;
};
